import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import ErrorView from '~common/components/error-view';
import { APIError } from '~common/lib/types';
import JsonLabel from '../../../../../common/ui/components/json-label-fc';
import URLManager from '~common/lib/url-manager';
import * as request from 'superagent';
import LoadingView from '~common/components/loading-view';
import {setValueAtPath} from '~common/form/helper';

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	userId: any;
}

type State = {
	status: "loading" | "ready"
	data: any;
	form: any;
	definitions: Array<any>;
	error?: any;
};

class UserEditor extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			data: {},
			form: {},
			definitions: [],
			status: "loading"
		};
	}

	
	handleErrorClose = () => {
		this.setState({error:null})
	  }

	componentDidMount() {
		// ATTENTION: DO NOT ALLOW A USER TO ADMIN THEIR OWN.		
		if (this.props.userId == (window as any).App.userContext.id) {
			const apiErr = new APIError()
			apiErr.type = "system"
			apiErr.message = "You Cannot Admin Your Own User, Redirecting to User Preferences"
			this.setState({error: apiErr})
			setTimeout(()=>{
				window.location.href = `/preferences?returnURL=/users/admin${window.location.search}`
			}, 3000)
			return
		} else {
			this.setState({status: "ready"})
		}
	}

	render() {

    const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;
		const {error} = this.state;
		var {status, data, form, definitions} = this.state

		// TODO: BD, add separate render case if ID is user ID to render a warning page and a link to user pref
		var errorView: any = null;
		if (error) {
			errorView = <ErrorView onClose={this.handleErrorClose} classes={{}} error={error.message} />;
		}

		var criteria = URLManager.getQueryString(window.location.href)
		
		switch(status) {
			case "loading":
				return <div>{errorView}<LoadingView classes={{}} /></div>
			case "ready":
				return (
					<div className={classes.container}>
						{errorView}
						<DefinitionDataProvider>
							<FormBasedContainer
								containerType={ContainerTypeEditor} 
								history={this.props.history} 
								match={match}
								clearDataOnSubmit={false}
								customRenderers={{"JsonLabel":JsonLabel}}
								dataUrl="/api/portal-users/editor"
								successMessage="User Successfully Saved"
								formSelector={{"formType": "userEditor", "modules": "users", "userType": "Any"}}
								returnURL={`/users/admin?q=${URLManager.getQueryStringValue(criteria)}`}
							>
							</FormBasedContainer>
						</DefinitionDataProvider>
					</div>
				);
		}
		
		
	}
}

export default withStyles(styles)(UserEditor);
